import React from "react";
import { images } from "../Images/Svg";
import { Box } from "@mui/system";
import { Button, Typography } from "@mui/material";
import CommonButton from "../CommonComponents/CommonButton";
import { useSelector } from "react-redux";
import Approval from "../Pages/CaseManagement/Actions/Approval";
import { useState } from "react";
import CommonModal from "../CommonComponents/Modal/CommonModal";

const { roundCloseIcon } = images;

const Tooltip = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  skipProps,
}) => {
  const { activeTourStep } = useSelector((state) => state.appTourSlice);
  const [openModal, setOpenModal] = useState(false);
  return (
    <Box
      {...tooltipProps}
      sx={{
        width: "390px",
        background: "white",
        padding: "10px",
        // border: "1px solid #9F9F9F",
        borderRadius: "10px",
      }}
    >
      <input type="hidden" id="skip" {...skipProps}></input>
      <CommonModal open={openModal} showCrossIcon={false}>
        <Approval
          message="Are you sure you want to close the tutorial?"
          onClick={(isSuccess) => {
            if (isSuccess) {
              document.getElementById("skip").click();
            } else {
              setOpenModal(false);
            }
          }}
        />
      </CommonModal>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 1rem 1rem 1rem",
          cursor: "pointer",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            color: "#3A3A3A",
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          {`${activeTourStep}/`}
          <p style={{ color: "#9F9F9F" }}>10</p>
        </Box>
        {activeTourStep > 0 && (
          <Box>
            {continuous && (
              <img
                onClick={() => setOpenModal(true)}
                src={roundCloseIcon}
                alt="tour close button"
              />
            )}
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: step.title ? "0.8rem" : "0rem",
          color: "#3A3A3A",
          fontSize: "16px",
          fontWeight: "600",
        }}
      >
        {step.title && step.title}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 1rem 0rem 1rem",
        }}
      >
        {step.content}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: activeTourStep === 0 ? "end" : "space-between",
          padding: "0 0rem 0rem 1rem",
        }}
      >
        {activeTourStep > 0 && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {continuous && (
              <Typography
                {...primaryProps}
                id="skip"
                sx={{
                  fontSize: "1.4rem",
                  color: "#9F9F9F",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                Skip
              </Typography>
            )}
          </Box>
        )}
        <Box>
          {index > 1 && (
            <Button
              {...backProps}
              sx={{
                "&:hover": {
                  backgroundColor: "white",
                },
              }}
            >
              <CommonButton label="Previous" borderRadius="7px" />
            </Button>
          )}
          {continuous && (
            <Button
              {...primaryProps}
              sx={{
                "&:hover": {
                  backgroundColor: "white",
                },
              }}
            >
              <CommonButton
                label={activeTourStep === 10 ? "Done" : "next"}
                filledButton
                borderRadius="7px"
              />
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Tooltip;
